export const CONFIRM_ENTITY_CSV_UPLOAD = 'CONFIRM_ENTITY_CSV_UPLOAD';
export const CONFIRM_SET_ENTITY_WHEN_FORM_IS_DIRTY = 'CONFIRM_SET_ENTITY_WHEN_FORM_IS_DIRTY';
